export enum FormatErrorSeverity {
  INFO = 0,
  WARNING = 1,
  ERROR = 2,
}
